import secondaryComponents from "../..";
import { PurchaseOrderImage } from "../../../../assets/svgImages";
import { extractReadableDateOnly } from "../../../../helpers";
import { WarningDialog } from "../../../common";
import { useGRExtra } from "../GRExtra/useGRExtra";
import { useGRNTable } from "./useGRNTable";

export const GRNTable = ({
  goodsReceived,
  metaDetails,
  gotoPage = () => {},
}) => {
  const { instance, selectedGRDetails, setSelectedGRDetails } = useGRNTable({
    goodsReceived,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  const { isDeletingGR, handleDeleteGR } = useGRExtra({
    closeModal: () => setSelectedGRDetails(null),
  });

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="pt-5 text-center">
          <PurchaseOrderImage />
          <h4>You have no GRN</h4>
          <p>
            Use the button above to create a GRN When you do, they would appear
            here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {goodsReceived?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <secondaryComponents.Modal
        isActive={!!selectedGRDetails}
        width={550}
        closeModal={() => setSelectedGRDetails(null)}
      >
        <WarningDialog
          title={`Delete GR: ${selectedGRDetails?.gr_number}`}
          closeModal={() => setSelectedGRDetails(null)}
          handler={() => handleDeleteGR(selectedGRDetails)}
          isLoading={isDeletingGR}
        >
          <p>
            Supplier:{" "}
            <span className="dark--text">
              {selectedGRDetails?.supplier?.name}
            </span>
          </p>
          <p>
            GR Date:{" "}
            <span className="dark--text">
              {selectedGRDetails?.gr_date
                ? extractReadableDateOnly(selectedGRDetails?.gr_date)
                : "N/A"}
            </span>
          </p>
        </WarningDialog>
      </secondaryComponents.Modal>
    </>
  );
};
